import apiClient from '../common/apiClient';

export default class RefreshTokenController {
  async Refresh(token) {
    try {
      return await apiClient.get('/refresh', {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
